import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { ResetPassword } from '@/components/auth';

const resetPasswordSearchSchema = z.object({
  email: z.string().optional(),
  token: z.string().optional(),
  campaignId: z.string().optional(),
});

export const Route = createFileRoute('/reset-password')({
  validateSearch: resetPasswordSearchSchema,
  beforeLoad: ({ context }) => {
    // Redirect authenticated users away from reset password
    if (context.auth.user) {
      throw redirect({ to: '/' });
    }
  },
  component: ResetPassword,
});
